import { z } from 'zod';

export type NSU = string;

export const NSU_PATTERN = /^[A-Za-z0-9]+-\d{8}-\d{6}$/;

export const NSUSchema = z.string().regex(NSU_PATTERN);

export function generateNSU(deviceId: string, date: Date, sequence: number): NSU {
  const sanitizedId = deviceId.replace(/[^A-Za-z0-9]/g, '');
  const dateStr = date.toISOString().slice(0, 10).replace(/-/g, '');
  const seq = String(sequence).padStart(6, '0');
  return `${sanitizedId}-${dateStr}-${seq}`;
}
